/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerConfirmContactsMutationRequest,
  TelegramUsersControllerConfirmContactsMutationResponse,
  TelegramUsersControllerConfirmContacts400,
  TelegramUsersControllerConfirmContacts401,
  TelegramUsersControllerConfirmContacts429,
} from '../types/TelegramUsersControllerConfirmContacts.ts';

function getTelegramUsersConfirmContactsUrl() {
  const res = { method: 'POST', url: `/api/telegram/users/confirm-contacts` as const };
  return res;
}

/**
 * {@link /api/telegram/users/confirm-contacts}
 */
export async function telegramUsersConfirmContacts(
  data: TelegramUsersControllerConfirmContactsMutationRequest,
  config: Partial<RequestConfig<TelegramUsersControllerConfirmContactsMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramUsersControllerConfirmContactsMutationResponse,
    ResponseErrorConfig<
      | TelegramUsersControllerConfirmContacts400
      | TelegramUsersControllerConfirmContacts401
      | TelegramUsersControllerConfirmContacts429
    >,
    TelegramUsersControllerConfirmContactsMutationRequest
  >({ method: 'POST', url: getTelegramUsersConfirmContactsUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
